import { render, staticRenderFns } from "./AlertingRule.vue?vue&type=template&id=940ba8e6&scoped=true&"
import script from "./AlertingRule.vue?vue&type=script&lang=js&"
export * from "./AlertingRule.vue?vue&type=script&lang=js&"
import style0 from "./AlertingRule.vue?vue&type=style&index=0&id=940ba8e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "940ba8e6",
  null
  
)

export default component.exports